import { combineReducers } from "redux";

import authenticationReducer from "./app/login/duck";
import navigationReducer from "./app/navbar/duck";
import gigReducers from "./app/gig/duck";
// import onboardingReducers from "./app/onboard/duck";
import questReducers from "./app/quest/duck";
import chatReducers from "./app/gig/chat/duck";
import notificationReducers from "./app/notifications/duck";
import searchReducer from "./app/search/duck";
import assessmentReducer from "./app/assessments/duck";
import userListGamePlayersReducer from "./app/profile/common/components/UserList/duck";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import commentReducers from "./app/comment/duck";
import profileReducers from "./app/profile/duck";
import jobListingsReducers from "./app/job-listings/duck";
import paymentReducers from "./app/payments/duck";
import programFinderReducer from "./app/programs/duck";
import plannerReducer from "./app/user-dashboard/duck";
import aiReducer from "./app/ai/duck";
import { marketplaceReducer } from "./app/marketplace/duck";

const userListGamePlayersPersistConfig = {
  key: "userListGamePlayers",
  storage: storage,
};

const gigDetailPersistConfig = {
  key: "gigDetail",
  storage: storage,
  transforms: [
    {
      // Define a transform function to exclude certain values during persisting
      in: (state, key) => {
        // Exclude a specific value from persisting
        return { ...state, isFetchingGigDetails: undefined };
      },
    },
  ],
};

const plannerConfig = {
  key: "planner",
  storage: storage,
  blacklist: ["applicationFormData", "shortlistedPrograms"],
};

const rootReducer = combineReducers({
  user: authenticationReducer,
  quests: questReducers,
  chat: chatReducers,
  gig: persistReducer(gigDetailPersistConfig, gigReducers),
  navbar: navigationReducer,
  notification: notificationReducers,
  search: searchReducer,
  assessment: assessmentReducer,
  userListGamePlayers: persistReducer(
    userListGamePlayersPersistConfig,
    userListGamePlayersReducer
  ),
  comments: commentReducers,
  profile: profileReducers,
  jobListings: jobListingsReducers,
  payments: paymentReducers,
  programFinder: programFinderReducer,
  planner: persistReducer(plannerConfig, plannerReducer),
  ai: aiReducer,
  marketplace: marketplaceReducer,
});

export default rootReducer;
